import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomePage.vue'),
    meta: {
      heading: 'Overview',
      requiresAuth: true,
      menu_meta: 'overview',
    },
  },
  {
    path: '/drawer/:id',
    name: 'home-drawer',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomePage.vue'),
    meta: {
      heading: 'Overview',
      requiresAuth: true,
      menu_meta: 'overview',
    },
  },
  {
    path: '/announcement/:id',
    name: 'announcement',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomePage.vue'),
    meta: {
      heading: 'Overview',
      requiresAuth: true,
      menu_meta: 'overview',
    },
  },
  {
    path: '/start-invite',
    name: 'invite',
    component: () => import(/* webpackChunkName: "invite" */ '../views/StartInvitePage.vue'),
    meta: {
      heading: 'Invite',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterPage.vue'),
    meta: {
      heading: 'Register',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginPage.vue'),
    meta: {
      heading: 'Login',
      login: true,
    },
  },
    {
    path: '/login-temp',
    name: 'login-temp',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginTempPage.vue'),
    meta: {
      heading: 'Login',
      login: true,
    },
  },
  {
    path: '/72f58e0d7f',
    name: 'motom-login',
    component: () => import(/* webpackChunkName: "motom-login" */ '../views/CjLoginPage.vue'),
    meta: {
      heading: 'Login',
      login: true,
    },
  },
    {
    path: '/get-started',
    name: 'motom-login-started',
    component: () => import(/* webpackChunkName: "motom-login" */ '../views/CjLoginPage.vue'),
    meta: {
      heading: 'Login',
      login: true,
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import(/* webpackChunkName: "forgot" */ '../views/ForgotPage.vue'),
    meta: {
      heading: 'Login',
      login: true,
    },
  },
  {
    path: '/reset-password',
    name: 'reset',
    component: () => import(/* webpackChunkName: "reset" */ '../views/ResetPasswordPage.vue'),
    meta: {
      heading: 'Login',
    },
  },
  {
    path: '/earnings',
    name: 'earnings',
    component: () => import(/* webpackChunkName: "earnings" */ '../views/EarningsPage.vue'),
    meta: {
      heading: 'Earnings',
      requiresAuth: true,
      menu_meta: 'earnings',
    },
  },
  // {
  //   path: '/messages',
  //   name: 'messages',
  //   component: () => import(/* webpackChunkName: "empty" */ '@shared/views/EmptyPage.vue'),
  //   meta: {
  //     heading: 'Messages',
  //     requiresAuth: true,
  //     menu_meta: 'messages',
  //   },
  // },

  // {
  //   path: '/messages/:id',
  //   name: 'message',
  //   component: () => import(/* webpackChunkName: "messages" */ '@shared/views/MessagesPage.vue'),
  //   meta: {
  //     heading: 'Messages',
  //     requiresAuth: true,
  //     menu_meta: 'messages',
  //   },
  // },

  {
    path: '/manage',
    name: 'empty-manage',
    component: () => import(/* webpackChunkName: "empty" */ '@shared/views/EmptyPage.vue'),
    meta: {
      heading: 'Manage',
      requiresAuth: true,
      menu_meta: 'manage',
    },
  },

  // Link-only user route (storefront_type === 10)
  {
    path: '/manage/:id/links',
    name: 'manage-links',
    component: () => import(/* webpackChunkName: "links" */ '@shared/views/LinksPage.vue'),
    meta: {
      heading: 'Manage',
      requiresAuth: true,
      menu_meta: 'manage',
    },
  },

  {
    path: '/manage/:id/:type',
    name: 'manage',
    component: () => import(/* webpackChunkName: "manage" */ '@/views/ManagePage.vue'),
    meta: {
      heading: 'Manage',
      requiresAuth: true,
      menu_meta: 'manage',
    },
  },

  //+++++++++++++++++++++++++++++++++++++
  //analytics
  //+++++++++++++++++++++++++++++++++++++
  {
    path: '/analytics-page',
    name: 'analytics-manage',
    component: () => import(/* webpackChunkName: "empty" */ '@shared/views/EmptyPage.vue'),
    meta: {
      heading: 'Analytics',
      requiresAuth: true,
      menu_meta: 'analytics',
    },
  },

  {
    path: '/analytics-page/:id/:type',
    name: 'analytics',
    component: () => import(/* webpackChunkName: "analytics" */ '../views/AnalyticsPage.vue'),
    meta: {
      heading: 'Analytics',
      requiresAuth: true,
      menu_meta: 'analytics',
    },
  },
  //+++++++++++++++++++++++++++++++++++++
  {
    path: '/social-insights',
    name: 'social-insights',
    component: () => import(/* webpackChunkName: "social-insights" */ '../views/SocialInsightsPage.vue'),
    meta: {
      heading: 'Social Insights',
      requiresAuth: true,
      menu_meta: 'social-insights',
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/SettingsPage.vue'),
    meta: {
      heading: 'Account Settings',
      requiresAuth: true,
    },
  },
  {
    path: '/pages/:slug',
    name: 'pages',
    component: () => import(/* webpackChunkName: "empty" */ '@shared/views/Pages.vue'),
  },
  {
    path: '/preview/post-content/:uid',
    name: 'preview-post-content',
    component: () => import(/* webpackChunkName: "preview-post-content" */ '@shared/views/PostPreviewContentPage.vue'),
  },
  {
    path: '/preview-academy/:ids?/:pageSlug?/:articleSlug?',
    name: 'preview-academy',
    component: () => import(/* webpackChunkName: "preview-academy" */ '@shared/views/PreviewCreatorAcademy.vue'),
  },
  {
    path: '/academy/:ids/:pageSlug?/:articleSlug?',
    name: 'academy',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomePage.vue'),
    meta: {
      requiresAuth: true,
      menu_meta: 'overview',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
  {
    path: '/del-qa-page',
    component: () => import(/* webpackChunkName: "del-qa-page" */ '../views/DelQaPage.vue'),
  },
];

let base_url = '/';

const router = createRouter({
  history: createWebHistory(base_url),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('token');
  // const redirectPath = window.localStorage.getItem('redirectPath');

  // 是否需要授權
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
      // 需要授權的頁面但沒token要跳轉
      window.localStorage.setItem('redirectPath', to.fullPath);
      next({ path: '/login' });
    } else {
      next();
    }
  }
  else {
    next();
  }
});

export default router;
